import { TFunction } from 'i18next'
import { AccessRight, AccessRightOptions } from 'src/Routes/Installation/InstallationModel'

export const getInstallationAccessRequestTextDescription = (permissionType: AccessRight, t: TFunction): string => {
  if (permissionType === AccessRightOptions.blocked) return t('installation.access-request-dialog.text-description-blocked')
  if (permissionType === AccessRightOptions.pending) return t('installation.access-request-dialog.text-description-pending')

  return t('installation.access-request-dialog.text-description-no-access')
}
